import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { ILearningProgram } from 'interfaces/roles'
import { useRolesAndPermissions } from '../../../../../context/RolesAndPermissionsContext'
import { Wrapper } from './styled'

interface IProps {
  learningProgram: ILearningProgram
  disabled?: boolean
}

export const Options = ({ learningProgram, disabled = false }: IProps) => {
  const { t } = useTranslation()
  const { removeLearningProgram } = useRolesAndPermissions()
  const prefix =
    'configuration.rolesAndPermissions.form.sections.accessToLearningPrograms.learningPrograms.table.actions'

  return (
    <Wrapper>
      <Tooltip
        getPopupContainer={() =>
          document.getElementById('lmsPage') as HTMLElement
        }
        title={t(`${prefix}.delete`)}
      >
        <Button
          onClick={() => removeLearningProgram(learningProgram.id)}
          type="link"
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </Tooltip>
    </Wrapper>
  )
}

export default Options
